import { FontFaces } from '@/models/FontFace'
import { MediaTypes } from '@/models/Types'

const env: string = process.env.NODE_ENV
const isDev: boolean = env === 'development'

const api = {
  baseURL: isDev ? 'http://cabinartists.local' : '',
  pagesURL: '/api/pages',
  navURL: '/api/nav',
  fetchOptions: { headers: { Accept: MediaTypes.JSON } },
}

const fonts:FontFaces = {
  default: {
    family: 'Montserrat',
    weight: 500,
    style: 'normal',
  },
  light: {
    family: 'Montserrat',
    weight: 300,
    style: 'normal',
  },
}

const meta: any = {
  title: 'Home',
  description: 'Cabin Artists is an international artist agency, founded in 2018.',
}

export {
  api,
  fonts,
  meta,
}
